<template lang="html">
  
  <div class="rubbish-container row-center aife">
    <span class="trash" :style="ownstyle.trash">
      <span :style="ownstyle.trash">
        <figure class="tapa" :style="ownstyle.trash"></figure>
      </span>
      <i></i>
    </span>
  </div>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      }),
      ownstyle : function(){
       return {
        trash : {
          background : this.colors.basic
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">

  .rubbish-container{
    cursor:pointer;
    height: 110px;
    width: 100px;
    -ms-align-items: flex-end;
    align-items: flex-end;
    -webkit-align-items: flex-end;
    transform: scale(.15);
  }

  .trash {
    background:#ff6873;
    width: 66px;
    height: 80px;
    display: inline-block;
    margin:0 auto;
    position: relative;
    -webkit-border-bottom-right-radius: 6px;
    -webkit-border-bottom-left-radius: 6px;
    -moz-border-radius-bottomright: 6px;
    -moz-border-radius-bottomleft: 6px;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    cursor: pointer;
    
  }

  .trash span {
    position: absolute;
    height: 12px;
    background: #ff6873;
    top: -19px;
    left: -10px;
    right: -10px;
    
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    transform: rotate(0deg);
    transition: transform 250ms;
    transform-origin: 19% 100%;
  }
  .trash span .tapa{
    content: '';
    position: absolute;
    width: 27px;
    height: 7px;
    background: #ff6873;
    top: -10px;
    
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    transform: rotate(0deg);
    transition: transform 250ms;
    transform-origin: 19% 100%;
    left: 27px;
  }


  .trash i {
    position:relative;
    width: 5px;
    height:50px;
    background:#fff;
    display:block;
    margin:14px auto;
    border-radius: 5px;
  }
  .trash i:after {
    content: '';
    width: 5px;
    height: 50px;
    background: #fff;
    position: absolute;
    left: -18px;
    border-radius: 5px;
  }
  .trash i:before {
    content: '';
    width: 5px;
    height: 50px;
    background: #fff;
    position: absolute;
    right: -18px;
    border-radius: 5px;
  }

  @media screen and (max-width: 1024px){


    .trash:hover span {
      transform: rotate(-45deg);
      transition: transform 250ms;
    }

  }

</style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/icons/rubbish.vue